import React, {  } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import dayjs, {  } from 'dayjs';


import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import DebugLog from '../utils/DebugLog';
const CustomDatePickerDialog = ({ open, onClose, onSelect , type}) => {
  const today = dayjs();
  const tomorrow = today.add(1, 'day');
  const [selectedDate, setSelectedDate] = React.useState(today);
 
  const handleClose = () => {
    DebugLog("selectedDate  "+dayjs(selectedDate).format('DD/MM/YYYY'))
    onClose();
  };

  const handleConfirm = () => {
    if(type==="scheduled") {
      const date = dayjs(selectedDate);
      if(date.isAfter(today)){
       // setSelectedDate(date);
       onSelect(dayjs(selectedDate).format('DD/MM/YYYY'));
       DebugLog("selectedDate  "+selectedDate)
       handleClose();
      }else{
        alert("Please choose future dates!")
      }
    }else{
      onSelect(dayjs(selectedDate).format('DD/MM/YYYY'));
      DebugLog("selectedDate  "+selectedDate)
      handleClose();
    }
    
  };

  return (
   
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Select Date</DialogTitle>
      
      <DialogContent>
      {type==="scheduled" ? (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DemoContainer components={['DatePicker']}>
        <DatePicker
            //defaultValue={setTodaysDate}
            label="Choose Date"
            value={selectedDate}
            onChange={(newValue) => setSelectedDate(newValue)}
            //maxDate={today}
            minDate={tomorrow}
           
          />
           </DemoContainer>
        </LocalizationProvider>
      ) : (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DemoContainer components={['DatePicker']}>
        <DatePicker
            //defaultValue={setTodaysDate}
            label="Choose Date"
            value={selectedDate}
            onChange={(newValue) => setSelectedDate(newValue)}
            maxDate={today}
            minDate={today}
           
          />
         
           </DemoContainer>
        </LocalizationProvider>
          )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleConfirm} color="primary">
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
   
  );
};

export default CustomDatePickerDialog;
